
import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faBook, faHandshake, faGlobe, faQuestionCircle, faSchool, faBriefcase, faBuilding, faBrain, faClock, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import ContiGif from '../header/images/Conti_gif.gif';
import ContiStartQuizGif from '../header/images/Conti_start_quiz.gif';
import EmiAsat from './EmiAsat';
import './QuizStart.css';
import '../content/bazelecontabilitatii/chaptercontainer.css';

// Mesaje personalizate pentru al cincilea quiz
const fifthQuizMessages = {
  '5 minute pe zi': 'Perfect pentru putin cate putin, in fiecare zi.',
  '10–15 minute pe zi': 'Un ritm echilibrat, usor de tinut.',
  '30 minute pe zi': 'Super! Avem timp sa aprofundam si sa exersam.'
};

// Mesaje personalizate pentru al saselea quiz
const sixthQuizMessages = {
  'Nu inca': 'E perfect in regula. Incepem clar, de la baza, fara sa presupunem nimic.',
  'Student': 'Super. Iti explic pe intelesul tau, astfel incat sa-ti fie usor sa legi teoria de practica.',
  'Contabil junior': 'Foarte bine. Consolidam ce stii deja si te ajut sa capeti mai multa siguranta in lucru.',
  'Economist': 'Perfect. Mergem mai aplicat si conectam conceptele la situatii reale din activitate.',
  'Antreprenor': 'Excelent. Ne concentram pe ce iti este util concret ca sa iti intelegi mai bine firma.',
  'Alt domeniu': 'Nicio problema. Adaptam explicatiile simplu si clar, fara termeni complicati.'
};

// Mesaje personalizate pentru al saptelea quiz
const seventhQuizMessages = {
  'Sa inteleg contabilitatea': 'Perfect. Construim totul logic si clar, astfel incat contabilitatea sa aiba sens pentru tine.',
  'Sa obtin un job': 'Super obiectiv. Ne concentram pe ce iti foloseste practic pentru a capata incredere si a te angaja.',
  'Sa promovez examene': 'Foarte bine. Organizăm invatarea astfel incat sa retii mai usor si sa fii pregatit pentru examene.',
  'Sa gestionez firma': 'Excelent. Punem accent pe partea practica, ca sa poti lua decizii mai bune pentru firma ta.',
  'Sa ma perfectionez': 'Perfect. Mergem mai in profunzime si rafinam cunostintele pe care le ai deja.'
};

// Mesaje personalizate pentru al optulea quiz
const eighthQuizMessages = {
  El: 'Perfect. O sa pastrez formularea la masculin, ca experienta sa fie cat mai naturala pentru tine.',
  Ea: 'Perfect. O sa pastrez formularea la feminin, ca experienta sa fie cat mai naturala pentru tine.',
  'Prefer sa nu spun': 'Nicio problema. Pastrez formularea neutra si mergem mai departe simplu si firesc.'
};

// Mesaje personalizate pentru al patrulea quiz
const fourthQuizMessages = {
  'Explicatii simple': 'Iti explic clar si pe intelesul tau, fara termeni complicati.',
  'Quiz-uri interactive': 'Invatam jucandu-ne si verificam imediat ce ai inteles.',
  'Aplicatii practice': 'Punem teoria in practica, cu exemple reale.'
};

// Mesaje personalizate pentru al treilea quiz
const thirdQuizMessages = {
  'Incepator total': 'Toata lumea incepe de undeva. Hai sa punem bazele pas cu pas',
  'Am notiuni de baza': 'Ai deja cateva notiuni. Te ajutam sa le legi corect si sa capete sens',
  'Ma descurc bine': 'Super! Hai sa consolidam cunostintele si sa trecem la aplicatii mai practice',
  'Avansat': 'Perfect. Ne concentram pe aplicatii, decizii contabile si situatii reale'
};

const quizSteps = [
  {
    question: 'Ce iti doresti sa inveti?',
    icon: faQuestionCircle,
    options: [
      { label: 'Bazele contabilitatii', icon: faBook },
      { label: 'Contabilitate financiara', icon: faHandshake },
      { label: 'Ambele', icon: faCheckCircle },
      { label: 'Nu stiu inca', icon: faQuestionCircle }
    ]
  },
  {
    question: 'De ce vrei sa inveti contabilitate?',
    icon: faBook,
    options: [
      { label: 'Pentru scoala sau facultate', icon: faSchool },
      { label: 'Pentru job', icon: faBriefcase },
      { label: 'Pentru firma mea', icon: faBuilding },
      { label: 'Pentru cultura generala', icon: faBrain },
      { label: 'Recapitulare cunostinte', icon: faCheckCircle }
    ]
  },
  {
    question: 'Cat de familiar esti cu contabilitatea?',
    icon: faBrain,
    options: [
      { label: 'Incepator total', icon: faQuestionCircle },
      { label: 'Am notiuni de baza', icon: faBook },
      { label: 'Ma descurc bine', icon: faCheckCircle },
      { label: 'Avansat', icon: faBrain }
    ]
  },
  {
    question: 'Cum vrei sa inveti?',
    icon: faBook,
    options: [
      { label: 'Explicatii simple', icon: faBook },
      { label: 'Quiz-uri interactive', icon: faQuestionCircle },
      { label: 'Aplicatii practice', icon: faCheckCircle }
    ]
  },
  {
    question: 'Cat timp vrei sa aloci?',
    icon: faClock,
    options: [
      { label: '5 minute pe zi', icon: faClock },
      { label: '10–15 minute pe zi', icon: faClock },
      { label: '30 minute pe zi', icon: faClock }
    ]
  },

  {
    question: 'Lucrezi deja in domeniu?',
    icon: faBriefcase,
    options: [
      { label: 'Nu inca', icon: faQuestionCircle },
      { label: 'Student', icon: faSchool },
      { label: 'Contabil junior', icon: faBriefcase },
      { label: 'Economist', icon: faBuilding },
      { label: 'Antreprenor', icon: faHandshake },
      { label: 'Alt domeniu', icon: faGlobe }
    ]
  },
  {
    question: 'Care e obiectivul tau principal?',
    icon: faCheckCircle,
    options: [
      { label: 'Sa inteleg contabilitatea', icon: faBook },
      { label: 'Sa obtin un job', icon: faBriefcase },
      { label: 'Sa promovez examene', icon: faSchool },
      { label: 'Sa gestionez firma', icon: faBuilding },
      { label: 'Sa ma perfectionez', icon: faBrain }
    ]
  },
    {
      question: 'Cum preferi sa ma adresez?',
    icon: faQuestionCircle,
    options: [
        { label: 'El', icon: faQuestionCircle },
        { label: 'Ea', icon: faQuestionCircle },
        { label: 'Prefer sa nu spun', icon: faQuestionCircle }
    ]
  }
];

const scrollViewportToTop = (container) => {
  const root = document.documentElement;
  const body = document.body;
  const appContainer = document.querySelector('.d-flex.flex-column.v-100');

  if (container) {
    container.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }

  window.scrollTo({ top: 0, left: 0, behavior: 'auto' });

  if (appContainer) {
    appContainer.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }

  root.scrollTop = 0;
  body.scrollTop = 0;
};

const QuizStart = () => {

  // step 0 = intro, step 1 = prima intrebare, etc
  const quizContainerRef = useRef(null);
  const quizBodyRef = useRef(null);
  const [step, setStep] = useState(0);
  const [selected, setSelected] = useState(Array(quizSteps.length).fill(null));
  const [isQuizBodyScrollable, setIsQuizBodyScrollable] = useState(false);

  useEffect(() => {
    scrollViewportToTop(quizBodyRef.current);
  }, [step]);

  useEffect(() => {
    const updateScrollableState = () => {
      const quizBody = quizBodyRef.current;

      if (!quizBody) {
        return;
      }

      if (!window.matchMedia('(max-width: 900px)').matches) {
        setIsQuizBodyScrollable(false);
        return;
      }

      const hasOverflow = quizBody.scrollHeight > quizBody.clientHeight + 1;
      setIsQuizBodyScrollable(hasOverflow);

      if (!hasOverflow) {
        quizBody.scrollTop = 0;
      }
    };

    updateScrollableState();

    const animationFrameId = window.requestAnimationFrame(updateScrollableState);
    window.addEventListener('resize', updateScrollableState);

    let resizeObserver;
    if (typeof ResizeObserver !== 'undefined' && quizBodyRef.current) {
      resizeObserver = new ResizeObserver(updateScrollableState);
      resizeObserver.observe(quizBodyRef.current);
    }

    return () => {
      window.cancelAnimationFrame(animationFrameId);
      window.removeEventListener('resize', updateScrollableState);
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  }, [step, selected]);

  useEffect(() => {
    const quizBody = quizBodyRef.current;

    if (!quizBody) {
      return undefined;
    }

    const preventTouchScroll = (event) => {
      if (!window.matchMedia('(max-width: 900px)').matches) {
        return;
      }

      if (!isQuizBodyScrollable) {
        event.preventDefault();
      }
    };

    quizBody.addEventListener('touchmove', preventTouchScroll, { passive: false });

    return () => {
      quizBody.removeEventListener('touchmove', preventTouchScroll);
    };
  }, [isQuizBodyScrollable]);

  useEffect(() => {
    const quizContainer = quizContainerRef.current;
    const quizBody = quizBodyRef.current;

    if (!quizContainer || !quizBody) {
      return undefined;
    }

    const preventContainerScroll = (event) => {
      if (!window.matchMedia('(max-width: 900px)').matches) {
        return;
      }

      const touchInsideQuizBody = quizBody.contains(event.target);

      if (!touchInsideQuizBody || !isQuizBodyScrollable) {
        event.preventDefault();
      }
    };

    quizContainer.addEventListener('touchmove', preventContainerScroll, { passive: false });

    return () => {
      quizContainer.removeEventListener('touchmove', preventContainerScroll);
    };
  }, [isQuizBodyScrollable]);

  useEffect(() => {
    const root = document.documentElement;
    const body = document.body;
    const previousRootOverflow = root.style.overflow;
    const previousBodyOverflow = body.style.overflow;
    const previousBodyTouchAction = body.style.touchAction;

    const applyMobileScrollLock = () => {
      if (window.matchMedia('(max-width: 900px)').matches) {
        root.style.overflow = 'hidden';
        body.style.overflow = 'hidden';
        body.style.touchAction = previousBodyTouchAction;
        scrollViewportToTop(quizBodyRef.current);
        return;
      }

      root.style.overflow = previousRootOverflow;
      body.style.overflow = previousBodyOverflow;
      body.style.touchAction = previousBodyTouchAction;
    };

    applyMobileScrollLock();
    window.addEventListener('resize', applyMobileScrollLock);

    return () => {
      window.removeEventListener('resize', applyMobileScrollLock);
      root.style.overflow = previousRootOverflow;
      body.style.overflow = previousBodyOverflow;
      body.style.touchAction = previousBodyTouchAction;
    };
  }, []);

  const handleSelect = (option) => {
    const newSelected = [...selected];
    newSelected[step - 1] = option;
    setSelected(newSelected);
  };

  const handleContinue = () => {
    const isOptionStep = step >= 1 && step <= quizSteps.length;
    if (isOptionStep && !selected[step - 1]) {
      return;
    }

    if (step < quizSteps.length + 2) {
      setStep(step + 1);
    }
  };

  // progress: 0 la intro, 100% la pasul de rezumat
  const progressStepsCount = quizSteps.length + 1;
  const progress = step === 0 ? 0 : Math.min(step, progressStepsCount) / progressStepsCount;
  const isSummaryStep = step === quizSteps.length + 1;
  const isFinalCtaStep = step === quizSteps.length + 2;

  const reasonSummaryMap = {
    'Pentru scoala sau facultate': 'vrei sa inveti contabilitate pentru scoala sau facultate',
    'Pentru job': 'vrei sa inveti contabilitate pentru job',
    'Pentru firma mea': 'vrei sa inveti contabilitate ca sa iti gestionezi firma',
    'Pentru cultura generala': 'vrei sa inveti contabilitate pentru cultura generala',
    'Recapitulare cunostinte': 'vrei sa iti recapitulazi cunostintele de contabilitate'
  };

  const levelSummaryMap = {
    'Incepator total': 'pornesti de la nivel incepator',
    'Am notiuni de baza': 'ai deja notiuni de baza',
    'Ma descurc bine': 'ai deja un nivel bun',
    'Avansat': 'ai deja un nivel avansat'
  };

  const objectiveSummaryMap = {
    'Sa inteleg contabilitatea': 'sa intelegi contabilitatea',
    'Sa obtin un job': 'sa obtii un job',
    'Sa promovez examene': 'sa promovezi examene',
    'Sa gestionez firma': 'sa gestionezi firma',
    'Sa ma perfectionez': 'sa te perfectionezi'
  };

  const reasonSummary = reasonSummaryMap[selected[1]] || 'vrei sa inveti contabilitate in ritmul tau';
  const levelSummary = levelSummaryMap[selected[2]] || 'pui bazele pas cu pas';
  const timeSummary = selected[4]
    ? `preferi sesiuni de ${selected[4].toLowerCase()}`
    : 'preferi sesiuni scurte si constante';
  const objectiveSummary = objectiveSummaryMap[selected[6]] || 'sa iti atingi obiectivul personal';

  const getSelectedOptionIcon = (stepIndex) => {
    const optionLabel = selected[stepIndex];
    const option = quizSteps[stepIndex]?.options.find(({ label }) => label === optionLabel);

    return option?.icon || faCheckCircle;
  };

  const summaryItems = [
    { icon: getSelectedOptionIcon(1), text: reasonSummary },
    { icon: getSelectedOptionIcon(2), text: levelSummary },
    { icon: getSelectedOptionIcon(4), text: timeSummary },
    { icon: getSelectedOptionIcon(6), text: `obiectivul tau este ${objectiveSummary}` }
  ];

  const onboardingAnswers = {
    learning_goal: selected[0] || null,
    reason: selected[1] || null,
    experience: selected[2] || null,
    learning_style: selected[3] || null,
    time_commitment: selected[4] || null,
    work_status: selected[5] || null,
    objective: selected[6] || null,
    pronoun: selected[7] || null,
  };

  const handleCreateAccountClick = () => {
    try {
      localStorage.setItem('onboardingAnswers', JSON.stringify(onboardingAnswers));
    } catch (error) {
      // Non-blocking: registration should still work even if storage is unavailable.
    }
  };

  // Mesaje personalizate pentru primul quiz
  const firstQuizMessages = {
    'Bazele contabilitatii': 'Incepem de la zero si construim pas cu pas, fara graba.',
    'Contabilitate financiara': 'Intram mai adanc in cifre si invatam cum functioneaza lucrurile in practica.',
    'Ambele': 'Perfect! Le combinam si inveti tot ce ai nevoie, echilibrat.',
    'Nu stiu inca': 'Nicio problema. Te ajut eu sa descoperim impreuna.'
  };

  // Mesaje personalizate pentru al doilea quiz
  const secondQuizMessages = {
    'Pentru scoala sau facultate': 'Te ajut sa intelegi lectiile si sa treci mai usor examenele.',
    'Pentru job': 'Hai sa inveti ce chiar conteaza la munca, clar si aplicat.',
    'Pentru firma mea': 'Iti arat cum sa-ti tii firma in ordine, fara stres.',
    'Pentru cultura generala': 'Ca sa stii ce se ascunde in spatele cifrelor de zi cu zi.',
    'Recapitulare cunostinte': 'Reimprospatam ce stii si punem totul cap la cap.'
  };

  const showHeader = !isFinalCtaStep;
  const progressWidth = step === 0 ? 0 : isSummaryStep ? 100 : progress * 100;

  return (
    <div ref={quizContainerRef} className="quiz-start-container quiz-fullscreen">
      <div className="quiz-shell">
        {showHeader ? (
          <div className="quiz-header">
            <button
              className="quiz-close-btn"
              aria-label="Închide quiz"
              onClick={() => window.history.back()}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
            <div className="quiz-progress-bar-wrap">
              <div className="quiz-progress-bar-bg">
                <div className="quiz-progress-bar" style={{width: `${progressWidth}%`}} />
              </div>
            </div>
          </div>
        ) : null}

        <div
          ref={quizBodyRef}
          className={`quiz-body${isQuizBodyScrollable ? ' quiz-body-scrollable' : ' quiz-body-static'}`}
        >
          {step === 0 ? (
            <>
          <div className="conti-intro">
            <div className="conti-speech-bubble">
              Salutare, eu sunt Conti!
              <div className="conti-speech-arrow" />
            </div>
            <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <img src={ContiGif} alt="Conti mascot" className="conti-mascot" />
              <div className="conti-mascot-shadow" />
            </div>
          </div>
            </>
          ) : isSummaryStep ? (
            <>

          <div className="quiz-question-row">
            <div className="quiz-mascot-wrap">
              <div className="quiz-mascot-img-wrap">
                <img src={ContiStartQuizGif} alt="Conti mascot" className="quiz-mascot-img" />
                <div className="quiz-mascot-shadow" />
              </div>
              <div className="quiz-question-bubble" style={{marginTop: 0, marginBottom: 0}}>
                Din raspunsurile tale am inteles ca:
              </div>
            </div>
          </div>

          <div className="quiz-options-grid">
            <div className="quiz-summary-panel">
             

              <div className="quiz-summary-lines">
                {summaryItems.map(({ icon, text }) => (
                  <div key={text} className="quiz-summary-line">
                    <FontAwesomeIcon icon={icon} className="quiz-summary-line-icon" />
                    <p>{text}</p>
                  </div>
                ))}
              </div>

              
             
            </div>
          </div>
            </>
          ) : isFinalCtaStep ? (
            <>
          <div className="conti-intro">
            <div className="conti-speech-bubble">
              
              <p>Mai ai doar un singur pas pentru a incepe.</p>
              <div className="conti-speech-arrow" />
            </div>
            <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <img src={ContiGif} alt="Conti mascot" className="conti-mascot" />
              <div className="conti-mascot-shadow" />
            </div>
          </div>
            </>
          ) : (
            <>
          <div className="quiz-question-row">
            <div className="quiz-mascot-wrap">
              <div className="quiz-mascot-img-wrap">
                <img src={ContiStartQuizGif} alt="Conti mascot" className="quiz-mascot-img" />
                <div className="quiz-mascot-shadow" />
              </div>
              {/* Mesaj personalizat la primul si al doilea quiz, altfel intrebarea */}
              {(step === 1 && selected[0]) ? (
                <div className="quiz-question-bubble" style={{marginTop: 0, marginBottom: 0}}>
                  {firstQuizMessages[selected[0]]}
                </div>
              ) : (step === 2 && selected[1]) ? (
                <div className="quiz-question-bubble" style={{marginTop: 0, marginBottom: 0}}>
                  {secondQuizMessages[selected[1]]}
                </div>
              ) : (step === 3 && selected[2]) ? (
                <div className="quiz-question-bubble" style={{marginTop: 0, marginBottom: 0}}>
                  {thirdQuizMessages[selected[2]]}
                </div>
              ) : (step === 4 && selected[3]) ? (
                <div className="quiz-question-bubble" style={{marginTop: 0, marginBottom: 0}}>
                  {fourthQuizMessages[selected[3]]}
                </div>
              ) : (step === 5 && selected[4]) ? (
                <div className="quiz-question-bubble" style={{marginTop: 0, marginBottom: 0}}>
                  {fifthQuizMessages[selected[4]]}
                </div>
              ) : (step === 6 && selected[5]) ? (
                <div className="quiz-question-bubble" style={{marginTop: 0, marginBottom: 0}}>
                  {sixthQuizMessages[selected[5]]}
                </div>
              ) : (step === 7 && selected[6]) ? (
                <div className="quiz-question-bubble" style={{marginTop: 0, marginBottom: 0}}>
                  {seventhQuizMessages[selected[6]]}
                </div>
              ) : (step === 8 && selected[7]) ? (
                <div className="quiz-question-bubble" style={{marginTop: 0, marginBottom: 0}}>
                  {eighthQuizMessages[selected[7]]}
                </div>
              ) : (
                <div className="quiz-question-bubble">
                  {quizSteps[step - 1].question}
                </div>
              )}
            </div>
          </div>
          <div className={`quiz-options-grid${quizSteps[step - 1].options.length > 3 ? ' quiz-options-grid-2col' : ''}`}>
            {quizSteps[step - 1].options.map(option => {
              const isSelected = selected[step - 1] === option.label;
              return (
                <button
                  key={option.label}
                  className={`quiz-answer-btn${isSelected ? ' quiz-answer-btn-selected' : ''}`}
                  onClick={() => handleSelect(option.label)}
                >
                  <FontAwesomeIcon icon={option.icon} className="quiz-answer-icon" />
                  <span className="quiz-answer-label">{option.label}</span>
                </button>
              );
            })}
          </div>
            </>
          )}
        </div>

        <div className="quiz-footer">
          <div className='group-quiz-start'>
            {step === 0 ? (
              <button
                className="conti-intro-btn"
                onClick={() => setStep(1)}
                type="button"
              >Continua</button>
            ) : isFinalCtaStep ? (
              <Link
                to="/registrer"
                state={{ onboardingAnswers }}
                onClick={handleCreateAccountClick}
                className="conti-intro-btn quiz-summary-cta"
              >
                Creeaza cont
              </Link>
            ) : (
              <button
                className="conti-intro-btn"
                onClick={handleContinue}
                disabled={!isSummaryStep && !selected[step - 1]}
                type="button"
              >Continua</button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuizStart;
